export const LOWER_BOUNDARY_MODAL_MESSAGE = 'Die untere Depotwertgrenze darf nicht kleiner Null sein.';
export const UPPER_BOUNDARY_MODAL_MESSAGE = 'Die obere Depotwertgrenze kann nicht grösser als der maximale Depotwert sein.'
export const INVERTED_BOUNDARIES_MODAL_MESSAGE = 'Die untere Depotwertgrenze kann nicht grösser oder gleich als die obere Depotwertgrenze sein.'
